import { useBooleanState } from '@cian/react-utils';
import React, { FC, useEffect } from 'react';

import { useApplicationContext } from '../../../../../utils/applicationContext';
import { YMEventsCenter } from '../YMEventsCenter';

/**
 * @description Центр инициализации Яндекс.Метрики
 */
export const YMInitAwaitCenter: FC = () => {
  const { config } = useApplicationContext();

  const ymCounterId = config.getStrict<number>('Yandex.Metrika.CounterId');

  const { state: ymInited, setTrue: setYMInited } = useBooleanState();

  useEffect(() => {
    if (!ymInited) {
      const type = `yacounter${ymCounterId}inited`;

      const listener = (): void => setYMInited();

      document.addEventListener(type, listener);

      return () => {
        document.removeEventListener(type, listener);
      };
    }

    return undefined;
  });

  if (ymInited) {
    return <YMEventsCenter ymCounterId={ymCounterId} />;
  }

  return null;
};
